import { render } from "./FinancialAdvice.vue?vue&type=template&id=17109f7e"
import script from "./FinancialAdvice.vue?vue&type=script&lang=js"
export * from "./FinancialAdvice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__